import styled from 'styled-components'
import Delete from '../../images/delete.svg'
import SuccessIcon from '../../images/successface.svg'
import Select from 'react-select'


export const DashboardContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: -50px;
  padding-top: 30px;
`

export const Bg = styled.div`
  min-height: 100vh;
  height: 100vh;
  width: 100%;
`

export const MainLayout = styled.div`
  float: right;
  display: flex;
  flex-direction: column;
  width: 80%;
  background-color: white;
`

export const MainContainer = styled.div`
  margin:auto;
  position:relative;
  width: 40%;
  padding-top:100px;
`

export const FormContainer = styled.div`
  margin:auto;
  position:relative;
  margin-top:3rem;
  width:100%;
`

export const BoxContainer = styled.div`
  display:flex;
  flex-direction:column;
  margin-top:0.3rem;
`

export const Name = styled.div`
font-family:Poppins;
font-weight:300;
font-size:0.8rem;
font-style:normal;
margin-left: 1rem;
color:#4F4F4F;
`

export const ButtonContainer = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
`
export const Button = styled.button`
  width: 16.3rem;
  height: 3rem;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  font-style:normal;
  text-align: center;
  color:#868383;
  margin-top: 0.5rem;
  border-radius: 10px;
  background-color:#EFF0F6;
  border: unset;
`
export const DeleteButton = styled.button`
  width: 8.8rem;
  height: 3rem;
  font-family: Poppins;
  font-size: 1rem;
  font-weight: 500;
  font-style:normal;
  text-align: center;
  color:#868383;
  margin-top: 0.5rem;
  padding-left: 5%;
  cursor: pointer;
  border-radius: 10px;
  background-color:#EFF0F6;
  background-image: url(${Delete});
  background-repeat: no-repeat;
  border: unset;
  background-position: bottom 50% left 12%;
`

export const FeedBack = styled.div`
  color: red;
  margin-left: 1rem;
  margin-top:-0.7rem;
  font-family: Poppins;
  font-weight: 400;
  font-size: 0.7rem;
`
export const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 5rem;
`

export const Success = styled.div`
  position: absolute;
  z-index: 10;
  top: 12rem;
  left: 25rem;
  height: 9rem;
  width: 15rem;
  border-radius: 0.5rem;
  text-align: center;
  background-color: #FFFCD3;
  font-family: Poppins;
`

export const TextSuccess = styled.div`
  margin-top: 1.5rem;
  font-size: 1.1rem;
`
export const ImgSuccess = styled.img`
  margin-top: 1rem;
  height: 4rem;
  src: url(${SuccessIcon});
`


export const TrainingChoices = styled.div`
  border:1px solid #979797;
  border-radius:10px;
  margin:0.5rem 0;
  padding: 0.5rem;
`
export const TrainingChoice = styled.div`
  margin:0.3rem;
`
export const TrainingInput = styled.input`
`

export const TrainingLabel = styled.label`
  font-family: Poppins;
  font-size: 15px;
  margin:0.5rem;
  margin-left: 10px;
  padding-bot: 11rem;
  cursor:  pointer;
  vertical-align: top;
`

export const LicenceSelector = styled(Select)`
.react-select__control {
  border-radius: 10px;
  width: 100%;
  color:black;
  font-family:Poppins;
  font-size:13px;
  outline: none;
  border: 1px solid #B3ABBC;
  height: 2.75rem;
  cursor: pointer;
}
.react-select__option {
  font-family: Poppins;
  font-size: 13px;
  cursor:  pointer;
}
.react-select__indicator-separator {
  display: none;
}
.react-select__dropdown-indicator {
  color: black;
}
  & .react-select__control--is-focused {box-shadow: 0px 0px 3px 3px #00C4F3;}
`

export const SelectorLicenceContainer = styled.div`
  margin-bottom: 1rem;
  margin-top: 0.7rem;
`
